import { useRef, useEffect } from 'react';
import { useContext, useContextSelector } from 'use-context-selector';
import { StickyControlContext, StickyValueContext } from '../contexts/internal/StickyContext.js';
import { quantizeSize } from '../utils/quantizeSize.js';

/**
 * Legacy bucketplace/ui에서 필요한 것들만 따로 옮겨두었습니다.
 * 새로만든 Sticky를 기획전에 적용할 수 있으면 제거하면 됩니다.
 */
var DEFAULT_STICKY_STATE = {
  disabled: true,
  emulatedDisabled: true,
  bottom: false,
  isAbsolute: false,
  isNativeSticky: false,
  offset: 0,
  emulatedOffset: 0,
  height: null,
  width: null,
  beginY: 0
};
function useStickyHeight(ref) {
  var _itemState$accumulate, _itemState$accumulate2, _itemState$accumulate3, _itemState$accumulate4, _itemState$accumulate5;
  var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
  var stickyControlContext = useContext(StickyControlContext);
  if (stickyControlContext == null) {
    throw new Error('StickyContext is not provided');
  }
  var stickyIdRef = useRef(null);
  var stickyId = stickyIdRef.current || stickyControlContext.register();
  stickyIdRef.current = stickyId;
  var itemState = useContextSelector(StickyValueContext, function (context) {
    if (context == null) {
      return null;
    }
    return context.entries[stickyId];
  });
  useEffect(function () {
    stickyControlContext.update(stickyId, ref, {
      shouldInfluenceScroll: false,
      direction: direction,
      offset: 0
    }, DEFAULT_STICKY_STATE);
  }, [stickyControlContext.update, stickyId, ref, direction]);
  useEffect(function () {
    // Unregister on unmount
    return function () {
      stickyControlContext.unregister(stickyId);
    };
  }, [stickyId]);
  return {
    min: quantizeSize((_itemState$accumulate = itemState === null || itemState === void 0 || (_itemState$accumulate2 = itemState.accumulatedOffsetRange) === null || _itemState$accumulate2 === void 0 ? void 0 : _itemState$accumulate2[0]) !== null && _itemState$accumulate !== void 0 ? _itemState$accumulate : 0),
    max: quantizeSize((_itemState$accumulate3 = itemState === null || itemState === void 0 || (_itemState$accumulate4 = itemState.accumulatedOffsetRange) === null || _itemState$accumulate4 === void 0 ? void 0 : _itemState$accumulate4[1]) !== null && _itemState$accumulate3 !== void 0 ? _itemState$accumulate3 : 0),
    current: quantizeSize((_itemState$accumulate5 = itemState === null || itemState === void 0 ? void 0 : itemState.accumulatedOffset) !== null && _itemState$accumulate5 !== void 0 ? _itemState$accumulate5 : 0)
  };
}

export { DEFAULT_STICKY_STATE, useStickyHeight };
//# sourceMappingURL=useStickyHeight.js.map
